export enum DurationType {
  Yearly = 'Yearly',
  Month = 'Month',
}
